import React, { memo } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { CONTEXT } from '../../../config';
import Loading from '../../../components/Loading/Loading';
import hint from '../../../static/wp_blank.png';
import styles from './TurnBlank.module.less';
import { logging } from '../../../actions/log';
import { handleLogin } from '../../../utils/hooks/useLoginStatus';
import { updateShowWpOrder } from '../../../actions/wallpaper';
import config from '../config';
import { openGroup, getVipState, getTurnList } from '../../../actions/wallpaperPay';
import Toast from '../../../components/Toast/Toast';
import { PCStoreJsBridge } from '../../../nativeapi';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectGroup = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.groupList,
);

const selectVip = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

export default memo(({ load, more, loginStatus = true }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const group = useSelector(selectGroup);
  const vip = useSelector(selectVip);

  const handleSkip = async id => {
    if (vip.vipState === 0 || null) {
      dispatch(
        updateShowWpOrder({
          show: true,
          wallpaperId: '',
          code: '',
          wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
          callbackTurnOrder: () => {},
          scenetype: 'resident_3btn', // 'set', 'dl', 'resident', 'resident_3btn', 'loop_single', 'loop_batch', 'loop_start'
        }),
      );
    } else {
      let res;
      if (id === 1) {
        res = await config.addWpToTurn({ contentList: [group.setup], type: '2' });
      } else if (id === 2) {
        res = await config.addWpToTurn({ contentList: [group.collect], type: '2' });
      } else {
        dispatch(openGroup(true));
      }
      if (res) {
        if (res?.status === 0) {
          Toast.success({
            content: '已成功添加至轮播列表',
          });
          dispatch(getTurnList({ pageCursor: '', refresh: true }));
          if (window.external && window.external.get_wallpaper_carousel_switch_info) {
            let switchData = JSON.parse(window.external.get_wallpaper_carousel_switch_info()) || {};
            if (switchData.switch === 'off') {
              PCStoreJsBridge.switchWpOpenTurn({
                switch: 'on',
                duration: switchData.duration,
              }).then(res => {
                if (res) {
                  window.PCStore_WpMine_TurnUpdate();
                }
              });
            }
          }
        } else if (![0, 1, 2, 3].includes(res?.status)) {
          Toast.error({
            content: '设置失败',
          });
        }
        dispatch(getVipState());
      }
    }

    // 更新页面 PV
    if (!id) {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_LookAround',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };

  const macInfo = localStorage.getItem('LOCALMACHINE_INFO');
  let mac = null;
  try {
    const { MAC } = JSON.parse(macInfo);
    mac = MAC;
  } catch (err) {
    mac = null;
  }

  if (!mac) {
    return (
      <>
        <div className={styles.blank}>
          <div className={classNames(styles.Img)}>
            <img src={hint} alt="" className={styles.backColor} />
          </div>
          <div className={styles.text}>抱歉，您访问的页面离家出走了</div>
          <div className={styles.retry}>
            <button type="button" className={styles.button} onClick={handleSkip}>
              随便逛逛
            </button>
          </div>
        </div>
      </>
    );
  }

  if (load) {
    return (
      <div className={styles.blank}>
        <div className={styles.load}>
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.blank}>
        <div className={classNames(styles.Img)}>
          <img src={hint} alt="" className={styles.backColor} />
        </div>
        {loginStatus && !more && (
          <>
            <div className={styles.text}>啊哦，您当前尚未添加壁纸</div>
            <div className={styles.retry}>
              <div className={styles.button} onClick={() => handleSkip(1)}>
                添加曾用壁纸
              </div>
              <div className={styles.button} onClick={() => handleSkip(2)}>
                添加收藏壁纸
              </div>
              <div className={styles.button} onClick={() => handleSkip(3)}>
                添加更多壁纸
              </div>
            </div>
          </>
        )}

        {loginStatus && more && <div className={styles.text}>壁纸持续扩充中，敬请留意：）</div>}
        {!loginStatus && (
          <div className={styles.text}>
            登录后，查看“曾用壁纸”
            <div className={styles.text_btn} onClick={handleLogin}>
              立即登录
            </div>
          </div>
        )}
      </div>
    </>
  );
});
